import { Component, OnDestroy, OnInit } from '@angular/core';
import { AlertController, ToastController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { InventarioService } from '../inventario.service';
import { SzerkZar, SzerkZarService } from '../../components/szerk-zar/szerk-zar.service';

/*  CIKKEK – a régi Inventario fő képernyőjének utódja: a cikklista vonalkóddal és készlettel, a
 *  szerkesztő egyedi mezőkkel (a cikk csoportja szerint) és képpel, a tömeges felvétel vonalkód-
 *  tartománnyal, a kijelölt cikkek tömeges szerkesztése, archiválása, címkéje, és az Excel-export.
 *  A cikktörzs közös a Számla és Kasszával. */
@Component({
  selector: 'app-inventario-cikkek',
  templateUrl: './cikkek.component.html',
  styleUrls: ['../../naplo/naplo-shared.scss', '../inventario-shared.scss'],
})
export class CikkekComponent implements OnInit, OnDestroy {
  cikkek: any[] = [];
  raktarak: any[] = [];
  mezok: any[] = [];
  sablonok: any[] = [];
  kereso = '';
  csoportSzuro = '';
  archiv = false;
  csakKeszletes = false;
  kijelolt = new Set<string>();
  szerk: any = null;
  tomeges: any = null;
  modositas: any = null;
  cimke: any = null;
  zar: SzerkZar | null = null;    // a nyitott cikk szerkesztési zárja
  private zarKor = 0;
  private sub?: Subscription;
  constructor(public inv: InventarioService, private toast: ToastController, private alert: AlertController, private szerkZar: SzerkZarService) {}
  get u() { return this.inv.aktiv.ugyfelId; }
  get ir() { return this.inv.ir; }

  async ngOnInit() {
    await this.inv.init();
    try { this.sablonok = await this.inv.get('/cimke-sablonok'); } catch { this.sablonok = []; }
    this.sub = this.inv.aktiv$.subscribe(() => this.frissit());
  }
  ngOnDestroy() { this.sub?.unsubscribe(); this.zarElenged(); }
  async frissit() {
    this.kijelolt.clear();
    if (!this.u) { this.cikkek = []; return; }
    try {
      const r: any = await this.inv.get(`/cikkek/${this.u}?archiv=${this.archiv ? 1 : 0}`);
      this.cikkek = r.cikkek || []; this.raktarak = r.raktarak || [];
      this.mezok = await this.inv.get(`/mezok/${this.u}`);
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült betölteni.'); }
  }
  get csoportok(): string[] { return [...new Set([...this.cikkek.map((c) => c.csoport), ...this.mezok.map((m) => m.csoport)].filter(Boolean))].sort(); }
  get lathato(): any[] {
    //  Olvasóhiba (régi programból): a magyar billentyűzeten az „í”/„ö” a „0” helyén jön.
    const k = this.kereso.trim().toLowerCase().replace(/[íö]/g, (x) => (/^[\díö-]+$/.test(this.kereso.trim()) ? '0' : x));
    return this.cikkek.filter((c) => (!this.csoportSzuro || c.csoport === this.csoportSzuro) && (!this.csakKeszletes || +c.keszletes)
      && (!k || [c.nev, c.cikkszam, c.vonalkod].some((x) => String(x || '').toLowerCase().includes(k))));
  }
  mezokCsoporthoz(cs: string | null): any[] { return this.mezok.filter((m) => !m.csoport || m.csoport === cs); }
  get mindKijelolve(): boolean { return this.lathato.length > 0 && this.lathato.every((c) => this.kijelolt.has(c.id)); }
  mindValt(v: boolean) { for (const c of this.lathato) { if (v) this.kijelolt.add(c.id); else this.kijelolt.delete(c.id); } }
  valt(c: any, v: boolean) { if (v) this.kijelolt.add(c.id); else this.kijelolt.delete(c.id); }

  /* ── szerkesztő ── */
  uj() {
    this.zarElenged();
    this.szerk = { id: null, nev: '', cikkszam: '', vonalkod: this.veletlenKod(), fajta: 'PRODUCT', egyseg: 'db', egysegar: null, afa_kulcs: '27', keszletes: true,
      csoport: this.csoportSzuro || '', mezok: {}, beszerzesi_ar: null, min_keszlet: null, szorzo: null, gyariszamos: false, aktiv: true, nyito: null, raktar_id: this.raktarak[0]?.id, kep: undefined };
  }
  nyit(c: any) { this.szerk = this.szerkAdat(c); this.zarFoglal(String(c.id)); }
  private szerkAdat(c: any) { return { ...c, mezok: { ...(c.mezok || {}) }, keszletes: !!+c.keszletes, gyariszamos: !!+c.gyariszamos, aktiv: !!+c.aktiv, kep: undefined }; }
  /*  SZERKESZTÉSI ZÁR (components/szerk-zar): a cikktörzs közös a Számla és Kasszával, ezért a zárfajta is
   *  ugyanaz (szamlazo_termek) – a két modulból nem írható felül egymás munkája. */
  private async zarFoglal(id: string) {
    this.zarElenged();
    if (!this.ir) return;
    const kor = this.zarKor;
    const z = await this.szerkZar.foglal('inventario', 'szamlazo_termek', id, { ujratolt: () => this.ujratolt(id) });
    if (kor !== this.zarKor || String(this.szerk?.id) !== id) { z?.felenged(); return; }
    this.zar = z;
  }
  private zarElenged() { this.zarKor++; this.zar?.felenged(); this.zar = null; }
  bezar() { this.szerk = null; this.zarElenged(); }
  //  A friss cikk a listából (a kijelölés megmarad), az ablak nyitva marad.
  private async ujratolt(id: string) {
    const r: any = await this.inv.get(`/cikkek/${this.u}?archiv=${this.archiv ? 1 : 0}`);
    this.cikkek = r.cikkek || [];
    const c = this.cikkek.find((x) => String(x.id) === id);
    if (c && String(this.szerk?.id) === id) this.szerk = this.szerkAdat(c);
  }
  //  A régi program 13 jegyű véletlen vonalkódja (1–9 számjegyekből), szerkeszthető.
  veletlenKod(): string { let s = ''; for (let i = 0; i < 13; i++) s += String(1 + Math.floor(Math.random() * 9)); return s; }
  bruttoAr(c: any): number { const k = ({ '27': 1.27, '18': 1.18, '5': 1.05 } as any)[c.afa_kulcs] || 1; return Math.round(Number(c.egysegar || 0) * k); }
  async kepValaszt(ev: Event) {
    const f = (ev.target as HTMLInputElement).files?.[0];
    (ev.target as HTMLInputElement).value = '';
    if (!f) return;
    //  Tömörítés: legfeljebb 800 px, JPEG (a régi program is tömörítette).
    const img = await new Promise<HTMLImageElement>((ok, rej) => { const i = new Image(); i.onload = () => ok(i); i.onerror = rej; i.src = URL.createObjectURL(f); });
    const arany = Math.min(1, 800 / Math.max(img.width, img.height));
    const cv = document.createElement('canvas'); cv.width = Math.round(img.width * arany); cv.height = Math.round(img.height * arany);
    cv.getContext('2d')!.drawImage(img, 0, 0, cv.width, cv.height);
    this.szerk.kep = cv.toDataURL('image/jpeg', 0.82);
  }
  kepUrl(c: any) { return `/api/inventario/cikk/${this.u}/${c.id}/kep`; }
  async kepNyit(c: any) { await this.inv.megnyit(`/cikk/${this.u}/${c.id}/kep`, c.nev); }
  async ment() {
    if (this.zar && !this.zar.irhato) return;
    try {
      await this.inv.post(`/cikk/${this.u}`, this.szerk);
      this.bezar(); this.ok('Cikk mentve.'); await this.frissit();
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült menteni.'); }
  }

  /* ── tömeges felvétel vonalkód-tartománnyal ── */
  tomegesNyit() { this.tomeges = { tol: '', ig: '', nev: '', egysegar: null, afa_kulcs: '27', egyseg: 'db', csoport: this.csoportSzuro || '', mezok: {}, keszletes: true, nyito: null, beszerzesi_ar: null, raktar_id: this.raktarak[0]?.id }; }
  get tomegesDb(): number {
    const a = String(this.tomeges?.tol || '').match(/(\d+)$/), b = String(this.tomeges?.ig || '').match(/(\d+)$/);
    return a && b ? Math.max(0, Number(b[1]) - Number(a[1]) + 1) : 0;
  }
  async tomegesMent() {
    try { const r: any = await this.inv.post(`/cikk/${this.u}/tomeges`, this.tomeges); this.tomeges = null; this.ok(`${r.db} cikk felvéve.`); await this.frissit(); }
    catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült.'); }
  }

  /* ── tömeges szerkesztés: mezőnként „változzon-e” ── */
  modositasNyit() { this.modositas = { mit: {} as any, valtozas: { nev: '', egysegar: null, afa_kulcs: '27', csoport: '', egyseg: 'db', beszerzesi_ar: null, min_keszlet: null, keszletes: true, aktiv: true }, mezok: {} as any }; }
  async modositasMent() {
    const m = this.modositas;
    const valtozas = Object.fromEntries(Object.entries(m.valtozas).filter(([k]) => m.mit[k]));
    const mezok = Object.fromEntries(Object.entries(m.mezok).filter(([k]) => m.mit['mezo:' + k]));
    try {
      const r: any = await this.inv.post(`/cikk/${this.u}/tomeges-modositas`, { idk: [...this.kijelolt], valtozas, mezok: Object.keys(mezok).length ? mezok : undefined });
      this.modositas = null; this.ok(`${r.db} cikk módosítva.`); await this.frissit();
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült.'); }
  }
  async archival(v: boolean) {
    try { await this.inv.post(`/cikk/${this.u}/tomeges-modositas`, { idk: [...this.kijelolt], valtozas: { aktiv: !v } }); this.ok(v ? 'Archiválva.' : 'Visszaállítva.'); await this.frissit(); }
    catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült.'); }
  }

  /* ── címke, export ── */
  nyomtatok: any[] = [];
  private tarolt(k: string, alap = ''): string { try { return localStorage.getItem(k) || alap; } catch { return alap; } }
  private tarol(k: string, v: string) { try { localStorage.setItem(k, v); } catch { /* */ } }
  async cimkeNyit() {
    //  A választott kódtípus, sablon és nyomtató gépenként megmarad (a régiben munkaterületi beállítás volt).
    this.cimke = { sablon: this.tarolt('inventarioSablon', this.sablonok[0]?.kod || 'a4_3x8'), peldany: 1,
      kodtipus: this.tarolt('inventarioKodtipus', 'code128'), nyomtato: this.tarolt('inventarioNyomtato') };
    /*  ASZTALI PROGRAM: a gép nyomtatói (pl. Brother QL-800 USB-n) – közvetlen nyomtatás párbeszédablak nélkül. */
    if (this.inv.nyomtatoHid) {
      try { this.nyomtatok = await this.inv.nyomtatoHid.nyomtatok(); } catch { this.nyomtatok = []; }
      if (!this.nyomtatok.some((p) => p.nev === this.cimke.nyomtato)) {
        this.cimke.nyomtato = (this.nyomtatok.find((p) => /QL[- ]?\d/i.test(p.nev)) || this.nyomtatok.find((p) => p.alapertelmezett) || this.nyomtatok[0])?.nev || '';
      }
      //  Brother nyomtatónál a Brother-sablon az ésszerű kezdés.
      if (/brother|QL/i.test(this.cimke.nyomtato) && !String(this.cimke.sablon).startsWith('brother')) this.cimke.sablon = 'brother_dk11209';
    }
  }
  get sablon(): any { return this.sablonok.find((s) => s.kod === this.cimke?.sablon); }
  async cimkeKozvetlen() {
    const c = this.cimke;
    this.tarol('inventarioKodtipus', c.kodtipus); this.tarol('inventarioSablon', c.sablon); this.tarol('inventarioNyomtato', c.nyomtato);
    try {
      const html = await this.inv.cimkeHtml({ idk: [...this.kijelolt], sablon: c.sablon, peldany: c.peldany, kodtipus: c.kodtipus });
      const s = this.sablon;
      const r = await this.inv.nyomtatoHid.nyomtat({ html, nyomtato: c.nyomtato, szelesseg_mm: s?.tekercs ? s.w : null, magassag_mm: s?.tekercs ? s.h : null });
      if (r?.ok) { this.ok(`Elküldve a nyomtatóra: ${c.nyomtato}`); this.cimke = null; } else this.hiba(r?.hiba || 'A nyomtatás nem sikerült.');
    } catch (e: any) { this.hiba(e?.error?.error || e?.message || 'A nyomtatás nem sikerült.'); }
  }
  async cimkeNyomtat() {
    this.tarol('inventarioKodtipus', this.cimke.kodtipus); this.tarol('inventarioSablon', this.cimke.sablon);
    try { await this.inv.postFajl(`/cimkek/${this.u}`, { idk: [...this.kijelolt], ...this.cimke }, 'cimkek.pdf'); this.cimke = null; }
    catch (e: any) { this.hiba('Nem sikerült a címkék elkészítése.'); }
  }
  async exportal() { try { await this.inv.getFajl(`/export/${this.u}`, 'keszlet-cikkek.xlsx'); } catch { this.hiba('Nem sikerült az export.'); } }

  szam(v: any) { return v == null || v === '' ? '' : Number(v).toLocaleString('hu-HU', { maximumFractionDigits: 2 }); }
  private async ok(m: string) { (await this.toast.create({ message: m, duration: 2600, color: 'success' })).present(); }
  private async hiba(m: string) { (await this.toast.create({ message: m, duration: 4200, color: 'danger' })).present(); }
}
